let GWP = {};
const GWPSchema = document.querySelector('[data-GWP-schema]');
if (GWPSchema) {
  GWP = JSON.parse(GWPSchema.innerHTML);
}

class customGWPJS {
  constructor() {
    this.ajaxCart = document.querySelector('cart-form');
    this._clearingCart = false;
  }

  getGwpVariantIds() {
    if (!GWP.threashould_1) return [];
    return [GWP.threashould_1.gwp_pro, GWP.threashould_1.gwp_pro_2]
      .filter((id) => id !== '' && id != null)
      .map((id) => Number(id));
  }

  isGwpGiftLine(product, gwpVariantIds) {
    const isGwpVariant = gwpVariantIds.includes(Number(product.variant_id));
    const isGwpProperty =
      product.properties && product.properties['product_type'] === 'GWP Gift';
    return isGwpVariant || isGwpProperty;
  }

  setCheckoutDisabled(disabled) {
    document
      .querySelectorAll('#checkout, button[name="checkout"], .checkout-btn')
      .forEach((btn) => {
        btn.disabled = disabled;
        if (disabled) btn.setAttribute('aria-disabled', 'true');
        else btn.removeAttribute('aria-disabled');
      });
  }

  clearCart() {
    if (this._clearingCart) return Promise.resolve();
    this._clearingCart = true;
    this.setCheckoutDisabled(true);

    const clearUrl =
      (window.routes && window.routes.cart_clear_url) || '/cart/clear.js';
    return fetch(clearUrl, fetchConfig())
      .then((response) => response.json())
      .then(() => {
        const freeGiftParent = document.querySelector('[data-freeGift]');
        if (freeGiftParent) {
          freeGiftParent.style.display = 'none';
          freeGiftParent.innerHTML = '';
        }
        if (this.ajaxCart) this.ajaxCart.getCartData();
      })
      .catch((e) => console.error(e))
      .finally(() => {
        this._clearingCart = false;
      });
  }

  /**
   * Block gift-only / $0 carts (e.g. free variant added via cart/add.js without qualifying purchase).
   * Returns true when cart was cleared and cartGWP should stop.
   */
  validateCartIntegrity(cart) {
    if (GWP.enable !== 'true' || this._clearingCart || !cart?.items?.length) {
      this.setCheckoutDisabled(false);
      return false;
    }

    const gwpVariantIds = this.getGwpVariantIds();
    let hasPaidMerchandise = false;

    cart.items.forEach((product) => {
      if (product.product_type === 'Gift Card') {
        hasPaidMerchandise = true;
        return;
      }
      if (!this.isGwpGiftLine(product, gwpVariantIds)) {
        hasPaidMerchandise = true;
      }
    });

    const giftOnlyCart = !hasPaidMerchandise;
    const zeroTotalCart = cart.total_price === 0;

    if (giftOnlyCart || (zeroTotalCart && !hasPaidMerchandise)) {
      this.clearCart();
      return true;
    }

    this.setCheckoutDisabled(zeroTotalCart);
    return false;
  }

  cartGWP() {
    this.ajaxCart = document.querySelector('cart-form');
    const cart = window.globalVariables.cart;
    if (!cart?.items) return;

    if (this.validateCartIntegrity(cart)) return;

    const gwpVariantIds = this.getGwpVariantIds();
    let GWPGift = false;
    let [threashouldValue, existedFreeProduct, existedFreeProductLine] = [
      null,
      null,
      null,
    ];
    let [finalThreshouldAmount, originalThreshouldAmount, updateQty] = [
      null,
      null,
      false,
    ];
    let [
      eligibleThreshould,
      eligibleFreeProduct,
      eligibleFreeProductJSON,
      eligibleFreeProduct_2,
      eligibleFreeProductJSON_2,
      cartTotal,
    ] = [null, null, null, null, null, 0];

    cart.items.forEach((product, index) => {
      if (this.isGwpGiftLine(product, gwpVariantIds)) {
        GWPGift = true;
        existedFreeProductLine = index + 1;
        existedFreeProduct = product.variant_id;
        if (product.quantity > 1) {
          updateQty = true;
        }
        if (
          product.variant_id == GWP.threashould_1['gwp_pro'] ||
          product.variant_id == GWP.threashould_1['gwp_pro_2']
        ) {
          threashouldValue = 1;
        }
      } else if (product.product_type != 'Gift Card') {
        cartTotal = cartTotal + product.final_line_price;
      }
    });

    if (GWP.enable == 'true' && cartTotal >= GWP.threashould_1['amount']) {
      eligibleThreshould = 1;
      let selectedThreashould = GWP[`threashould_${eligibleThreshould}`];
      [
        eligibleFreeProduct,
        eligibleFreeProductJSON,
        eligibleFreeProduct_2,
        eligibleFreeProductJSON_2,
      ] = [
        selectedThreashould.gwp_pro,
        selectedThreashould.gwp_pro_JSON,
        selectedThreashould.gwp_pro_2,
        selectedThreashould.gwp_pro_JSON_2,
      ];
      [finalThreshouldAmount, originalThreshouldAmount] = [
        selectedThreashould.amount,
        selectedThreashould.original_amount,
      ];
    }

    let removeProduct = JSON.stringify({
      line: existedFreeProductLine,
      quantity: 0,
    });

    if ((GWP == undefined || eligibleThreshould == null) && GWPGift) {
      this.updateGWPvariant(removeProduct, () => {
        if (this.ajaxCart) this.ajaxCart.getCartData();
      });
    } else if (
      (threashouldValue &&
        threashouldValue != eligibleThreshould &&
        (eligibleFreeProduct != null || eligibleFreeProduct_2 != null)) ||
      (existedFreeProduct != null &&
        existedFreeProduct != eligibleFreeProduct &&
        existedFreeProduct != eligibleFreeProduct_2)
    ) {
      this.updateGWPvariant(removeProduct, () => {
        if (this.ajaxCart) this.ajaxCart.getCartData();
        this.showFreeProduct(
          originalThreshouldAmount,
          finalThreshouldAmount,
          eligibleFreeProductJSON,
          eligibleFreeProductJSON_2
        );
      });
    } else if (updateQty) {
      let updateProduct = JSON.stringify({
        line: existedFreeProductLine,
        quantity: 1,
      });
      this.updateGWPvariant(updateProduct, () => {
        if (this.ajaxCart) this.ajaxCart.getCartData();
      });
    } else if (
      eligibleThreshould != null &&
      eligibleFreeProduct != null &&
      !GWPGift
    ) {
      this.showFreeProduct(
        originalThreshouldAmount,
        finalThreshouldAmount,
        eligibleFreeProductJSON,
        eligibleFreeProductJSON_2
      );
    } else {
      const freeGiftParent = document.querySelector('[data-freeGift]');
      if (freeGiftParent) {
        freeGiftParent.style.display = 'none';
        freeGiftParent.innerHTML = '';
      }
    }
  }

  updateGWPvariant(body, callback) {
    let checkoutBtn = document.querySelector('.checkout-btn');
    if (checkoutBtn) {
      checkoutBtn.classList.add('disabled');
    }
    let fetchCart = fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body },
    });
    fetchCart
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (typeof callback == 'function') return callback(response);
      })
      .catch((e) => {
        console.error(e);
        return callback(e);
      })
      .finally(() => {
        if (checkoutBtn) {
          checkoutBtn.classList.remove('disabled');
        }
      });
  }

  showFreeProduct(
    originalThreshouldAmount,
    finalThreshouldAmount,
    eligibleFreeProductJSON,
    eligibleFreeProductJSON_2
  ) {
    if (
      eligibleFreeProductJSON == null &&
      eligibleFreeProductJSON_2 == null
    ) {
      return;
    }

    let freeProductsHTML = `
        <div class="gwp-item">
            <div class="d-flex cart-product-img align-items-center  bg-gray-500 p-3">
                <div class="cart-img flex-shrink-0 overflow-hidden">
                    <a class="d-block h-100" href="/products/${eligibleFreeProductJSON.handle}">
                        <img class="gift_img" src="${eligibleFreeProductJSON.featured_image}" loading="lazy" width="120" height="120" />
                    </a>
                </div>
                <div class="cart-item-text ps-3">
                    <a href="/products/${eligibleFreeProductJSON.handle}" class="card-title fw-medium mb-2">${eligibleFreeProductJSON.title}</a>
                    <div class="cart-price">
                        <span class="orgi_price ajaxcart__price">$0 | <del>${Utility.formatMoney(eligibleFreeProductJSON.compare_at_price, window.globalVariables.money_format)}</del></span>
                    </div>
                    <div class="quantity-box mt-3">
                        <a type="button" name="add" class="btn-link fs-sm fw-semibold add-to-cart" data-originalThreshouldAmount="${originalThreshouldAmount}" data-addID="${eligibleFreeProductJSON.variants[0].id}" data-addFreeItem><span>Add </span></a>
                    </div>
                </div>
                </div>
            </div>`;
    if (eligibleFreeProductJSON_2) {
      freeProductsHTML += `
            <div class="gwp-item">
                <div class="d-flex cart-product-img  align-items-center  bg-gray-500 p-3">
                    <div class="cart-img flex-shrink-0 overflow-hidden">
                        <a class="d-block h-100" href="/products/${eligibleFreeProductJSON_2.handle}">
                            <img class="gift_img" src="${eligibleFreeProductJSON_2.featured_image}" loading="lazy" width="120" height="120" />
                        </a>
                    </div>
                    <div class="cart-item-text ps-3">
                        <a href="/products/${eligibleFreeProductJSON_2.handle}" class="card-title fw-medium mb-2">${eligibleFreeProductJSON_2.title}</a>
                        <div class="cart-price">
                            <span class="orgi_price ajaxcart__price">$0 | <del>${Utility.formatMoney(eligibleFreeProductJSON_2.compare_at_price, window.globalVariables.money_format)}</del></span>
                        </div>
                        <div class="quantity-box mt-3">
                            <a type="button" name="add" class="btn-link fs-sm fw-semibold add-to-cart" data-originalThreshouldAmount="${originalThreshouldAmount}" data-addID="${eligibleFreeProductJSON_2.variants[0].id}" data-addFreeItem><span>Add</span></a>
                        </div>
                    </div>
                    </div>
                </div>`;
    }

    let freeProductwrapperHTML = `<div class=""><div class="col-12 gift_prod_heading">
                                        <div class="general-text mb-3 fw-semibold">Add Any 1 Free Gift</div>
                                        </div>
                                        <div class="">${freeProductsHTML}</div>`;
    const freeGiftParent = document.querySelector('[data-freeGift]');
    if (freeGiftParent) {
      freeGiftParent.innerHTML = freeProductwrapperHTML;
      freeGiftParent.style.display = 'block';
    }
    const addItemBtns = document.querySelectorAll('[data-addFreeItem]');
    if (addItemBtns.length == 0) return;
    addItemBtns.forEach((addBtn) => {
      addBtn.addEventListener('click', (event) => {
        event.preventDefault();
        addItemBtns.forEach((addBtn) => {
          addBtn.classList.add('disabled');
        });
        const currentTarget = event.currentTarget;
        const body = JSON.stringify({
          id: currentTarget.getAttribute('data-addid'),
          quantity: 1,
          properties: {
            product_type: 'GWP Gift',
            spend_over: currentTarget.getAttribute('data-originalThreshouldAmount'),
          },
        });
        let fetchCart = fetch(`${routes.cart_add_url}`, {
          ...fetchConfig(),
          ...{ body },
        });
        fetchCart
          .then((response) => {
            return response.json();
          })
          .then((_response) => {
            if (this.ajaxCart) this.ajaxCart.getCartData();

            freeGiftParent.style.display = 'none';
            freeGiftParent.innerHTML = '';
          })
          .catch((e) => {
            console.error(e);
          });
      });
    });
  }
}

window.gwpHandler = new customGWPJS();
window.gwpHandler.cartGWP();
